export default {
	"locale": "vi",
	"long": {
		"year": {
			"previous": "năm ngoái",
			"current": "năm nay",
			"next": "năm sau",
			"past": "{0} năm trước",
			"future": "sau {0} năm nữa"
		},
		"quarter": {
			"previous": "quý trước",
			"current": "quý này",
			"next": "quý sau",
			"past": "{0} quý trước",
			"future": "sau {0} quý nữa"
		},
		"month": {
			"previous": "tháng trước",
			"current": "tháng này",
			"next": "tháng sau",
			"past": "{0} tháng trước",
			"future": "sau {0} tháng nữa"
		},
		"week": {
			"previous": "tuần trước",
			"current": "tuần này",
			"next": "tuần sau",
			"past": "{0} tuần trước",
			"future": "sau {0} tuần nữa"
		},
		"day": {
			"previous": "Hôm qua",
			"previous-2": "Hôm kia",
			"current": "Hôm nay",
			"next": "Ngày mai",
			"next-2": "Ngày kia",
			"past": "{0} ngày trước",
			"future": "sau {0} ngày nữa"
		},
		"hour": {
			"current": "giờ này",
			"past": "{0} giờ trước",
			"future": "sau {0} giờ nữa"
		},
		"minute": {
			"current": "phút này",
			"past": "{0} phút trước",
			"future": "sau {0} phút nữa"
		},
		"second": {
			"current": "bây giờ",
			"past": "{0} giây trước",
			"future": "sau {0} giây nữa"
		}
	},
	"short": {
		"year": {
			"previous": "năm ngoái",
			"current": "năm nay",
			"next": "năm sau",
			"past": "{0} năm trước",
			"future": "sau {0} năm nữa"
		},
		"quarter": {
			"previous": "quý trước",
			"current": "quý này",
			"next": "quý sau",
			"past": "{0} quý trước",
			"future": "sau {0} quý nữa"
		},
		"month": {
			"previous": "tháng trước",
			"current": "tháng này",
			"next": "tháng sau",
			"past": "{0} tháng trước",
			"future": "sau {0} tháng nữa"
		},
		"week": {
			"previous": "tuần trước",
			"current": "tuần này",
			"next": "tuần sau",
			"past": "{0} tuần trước",
			"future": "sau {0} tuần nữa"
		},
		"day": {
			"previous": "hôm qua",
			"previous-2": "Hôm kia",
			"current": "hôm nay",
			"next": "ngày mai",
			"next-2": "Ngày kia",
			"past": "{0} ngày trước",
			"future": "sau {0} ngày nữa"
		},
		"hour": {
			"current": "giờ này",
			"past": "{0} giờ trước",
			"future": "sau {0} giờ nữa"
		},
		"minute": {
			"current": "phút này",
			"past": "{0} phút trước",
			"future": "sau {0} phút nữa"
		},
		"second": {
			"current": "bây giờ",
			"past": "{0} giây trước",
			"future": "sau {0} giây nữa"
		}
	},
	"narrow": {
		"year": {
			"previous": "năm ngoái",
			"current": "năm nay",
			"next": "năm sau",
			"past": "{0} năm trước",
			"future": "sau {0} năm nữa"
		},
		"quarter": {
			"previous": "quý trước",
			"current": "quý này",
			"next": "quý sau",
			"past": "{0} quý trước",
			"future": "sau {0} quý nữa"
		},
		"month": {
			"previous": "tháng trước",
			"current": "tháng này",
			"next": "tháng sau",
			"past": "{0} tháng trước",
			"future": "sau {0} tháng nữa"
		},
		"week": {
			"previous": "tuần trước",
			"current": "tuần này",
			"next": "tuần sau",
			"past": "{0} tuần trước",
			"future": "sau {0} tuần nữa"
		},
		"day": {
			"previous": "hôm qua",
			"previous-2": "Hôm kia",
			"current": "hôm nay",
			"next": "ngày mai",
			"next-2": "Ngày kia",
			"past": "{0} ngày trước",
			"future": "sau {0} ngày nữa"
		},
		"hour": {
			"current": "giờ này",
			"past": "{0} giờ trước",
			"future": "sau {0} giờ nữa"
		},
		"minute": {
			"current": "phút này",
			"past": "{0} phút trước",
			"future": "sau {0} phút nữa"
		},
		"second": {
			"current": "bây giờ",
			"past": "{0} giây trước",
			"future": "sau {0} giây nữa"
		}
	}
}